import { Stack, Typography } from '@mui/material';

import { FormAwareSwitch } from '@/components/form/formAwareInputs/FormAwareSwitch';
import { Card } from '@/components/layout/Card/Card';
import { PopperContent } from '@/components/poppers/PopperContent';
import { useFormContext } from '@/components/react-hook-form';

import {
  FullScreenStructuredAssetsModalForm,
  FullScreenStructuredAssetsModalFormPath,
} from './FullScreenStructuredAssetsModal.types';

const REAL_TPP_TOGGLE_HELP_BODY =
  "When enabled, real property and tangible personal property held in this entity will be subject to state estate tax based on the state where it is located. When disabled, any real and tangible personal property interest in the entity will be treated as intangible personal property located in the owner's state of domicile.";

export function TaxExposureCard() {
  const { control } = useFormContext<FullScreenStructuredAssetsModalForm>();

  return (
    <Card variant="filled">
      <Stack spacing={2} p={2}>
        <Typography variant="title-s" component="span">
          Tax exposure
        </Typography>
        <FormAwareSwitch<FullScreenStructuredAssetsModalForm>
          fieldName={
            'enableRealTppTaxExposure' as const satisfies FullScreenStructuredAssetsModalFormPath
          }
          label="Enable tax exposure for real and tangible personal property"
          control={control}
          labelPosition="right"
          variant="dark"
          contextualHelp={<PopperContent body={REAL_TPP_TOGGLE_HELP_BODY} />}
        />
      </Stack>
    </Card>
  );
}
